import cronstrue from 'cronstrue';

export function formatSchedule(schedule: string): string {
  try {
    return cronstrue.toString(schedule);
  } catch {
    return schedule;
  }
}
